import "./App.css";
import { Route, Routes } from "react-router-dom";
import ProtectedRoutesOutlet from "./_routes/ProtectedRotuesOutlet";
import ProtectedRotues from "./_routes/ProtectedRoutes";
import { Toaster } from "react-hot-toast";
import PublicRoutes from "./_routes/PublicRoutes";
import PublicRoutesOutlet from "./_routes/PublicRotuesOutlet";
import {useSelector} from 'react-redux'
import Loader from "./_components/common/Loader";
import NotFound from "./_components/common/NotFound";

function App() {

const userInfo = useSelector(state=>state.user)
const isLoading = useSelector(state=>state.loader.isLoading)
const role = (userInfo?.role || 'user').toLowerCase()

  return (
    <div className="app-root">
      <Toaster
        position="top-right"
        containerClassName="hot-toaster-container"
      />

      {isLoading && <Loader />}
      <Routes>
        <Route element={<ProtectedRoutesOutlet />}>
       {
        ProtectedRotues.filter(route => route.allowedRoles.includes(role)).map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))
       }
        </Route>
        <Route element={<PublicRoutesOutlet />}>
          {PublicRoutes?.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
